import {RedeemCodeTypeVo} from '../../common/shared/api/nicolas/vo/enums/RedeemCodeTypeVo.enum';
import {RedeemCodeType} from '../generated/types';

export function createRedeemCodeType(
  redeemCodeVo?: RedeemCodeTypeVo
): RedeemCodeType {
  if (!redeemCodeVo) {
    return RedeemCodeType.None;
  }
  // 이용권 리딤코드의 경우 type이 RT(NN)나 TT(NN)으 내려오는 경우가 존재합니다. 뒤에 숫자에 상관없이 티켓 여부를 판단합니다.
  if (redeemCodeVo.includes('RT')) {
    return RedeemCodeType.TicketRent;
  } else if (redeemCodeVo.includes('TT')) {
    return RedeemCodeType.TicketBuy;
  }

  return redeemCodeTypeMap[redeemCodeVo];
}

const redeemCodeTypeMap: {[key in RedeemCodeTypeVo]: RedeemCodeType} = {
  [RedeemCodeTypeVo.Credit]: RedeemCodeType.Credit,
  [RedeemCodeTypeVo.Gacha]: RedeemCodeType.Gacha,
  [RedeemCodeTypeVo.Ticket]: RedeemCodeType.Ticket,
  [RedeemCodeTypeVo.TicketBuy]: RedeemCodeType.TicketBuy,
  [RedeemCodeTypeVo.TicketRent]: RedeemCodeType.TicketRent,
  [RedeemCodeTypeVo.Point]: RedeemCodeType.Point,
  [RedeemCodeTypeVo.None]: RedeemCodeType.None,
};
